import { render, staticRenderFns } from "./DayDetails.vue?vue&type=template&id=a04ff0fa&scoped=true&"
import script from "./DayDetails.vue?vue&type=script&lang=ts&"
export * from "./DayDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04ff0fa",
  null
  
)

export default component.exports